import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';

@Component({
  selector: 'app-dialog-submit-service-changes',
  templateUrl: './dialog-submit-service-changes.component.html',
  styleUrls: ['./dialog-submit-service-changes.component.scss']
})
export class DialogSubmitServiceChangesComponent extends BaseGeneralComponent implements OnInit {

  dataValues: any;
  displayedColumns: string[];

  constructor(public dialogData: MatDialogRef<DialogSubmitServiceChangesComponent>, @Inject(MAT_DIALOG_DATA) data) {
    super();
    this.displayedColumns = ['Confirmed', 'ProviderDesc', 'NumAnnoMese', 'RegionDesc', 'LocalCustomerDesc', 'ResourceUnitName', 'ShareName',
      'applicationCod', 'delta', 'ContractType'];
    this.dataValues = data.result;
  }

  ngOnInit() {
  }

  save() {
    this.dialogData.close();
  }

  close() {
    this.dialogData.close();
  }

}

